// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { RoleAnalysisStatusSchema } from '../inputTypeSchemas/RoleAnalysisStatusSchema'

/////////////////////////////////////////
// APPLICATION ROLE SCHEMA
/////////////////////////////////////////

export const ApplicationRoleSchema = z.object({
  analysisStatus: RoleAnalysisStatusSchema.nullable(),
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  name: z.string(),
  description: z.string().nullable(),
  aiGeneratedDescription: z.string().nullable(),
  analysisJobId: z.string().nullable(),
  analysisError: z.string().nullable(),
  lastAnalyzedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type ApplicationRole = z.infer<typeof ApplicationRoleSchema>

export default ApplicationRoleSchema;
